<div class="reward-created-modal-root">
  <div class="header">
    <h1>{{ labels.rewardCreated }}</h1>
  </div>
  <div class="body">
    <h2>{{ labels.added }}</h2>
    <span>{{ labels.canCheck }}</span>
    <span>
      <strong>{{ labels.canEdit }}</strong>
    </span>
  </div>
  <div class="footer">
    <button mat-stroked-button color="primary" (click)="goToProductsPanel()">
      {{ labels.goToProducts }}
    </button>
    <button mat-flat-button color="primary" (click)="goToRewardsList()">
      {{ labels.goToRewards }}
    </button>
  </div>
</div>
